import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { createAction } from '../../../../ducks/actions'
import { getCurrentOrganizationId } from '../../../../ducks/users'

import ChooseType from './ChooseType'

export default function FirstStep() {
  const dispatch = useDispatch()
  const history = useHistory()
  const [submitting, setSubmitting] = useState(false)
  const organizationId = useSelector(getCurrentOrganizationId)

  // TODO: Redirect if newAction already exists
  // If step is half-finished, go to step setup?
  // Maybe add a "draft: true" flag that is saved on the step

  const handleChoose = async step => {
    setSubmitting(true)

    try {
      let result = await dispatch(createAction(organizationId, step))

      let actionId = result.value.data.id

      // Redirect to step 2
      history.push(`/actions/${actionId}/steps/${step.id}`)
    } catch (err) {
      // TODO: show an error
      console.error(err)
    }

    setSubmitting(false)
  }

  return (
    <ChooseType
      history={history}
      onChoose={handleChoose}
      submitting={submitting}
      title="Create New Action"
    />
  )
}
